<template>
  <div id="body">
    <img src="http://yd.top917.cn/date/images/yq_01.jpg">
    <img src="http://yd.top917.cn/date/images/yq_02.jpg">
    <img src="http://yd.top917.cn/date/images/yq_03.jpg">
    <div class="doce">
      <img class='doce_spr' :src="myimg.img" />
      <img src="http://yd.top917.cn/date/images/yq_04.jpg">
    </div>
    <img src="http://yd.top917.cn/date/images/yq_05.jpg">
    <img src="http://yd.top917.cn/date/images/yq_06.jpg">
    <img src="http://yd.top917.cn/date/images/yq_07.jpg">
    <img src="http://yd.top917.cn/date/images/yq_08.jpg">
    <img src="http://yd.top917.cn/date/images/yq_09.jpg">
    <img src="http://yd.top917.cn/date/images/yq_10.jpg">
  </div>
  
</template>
<style scoped>
   .doce{
    position:relative;
  }
  .doce_spr{
    position: absolute;
    width: 2rem;
    left: 2.8rem;
    top: 2.5rem;
  }
  img{
    width: 100%;
    display: block;
  }
</style>

<script>
import { getMyimg } from "@api/user";
export default {
  name: "Poster",
  components: {},
  props: {},
  data: function() {
    return {
     myimg:{},
    };
  },
  mounted: function() {
	  this.Myimg();
  },
  methods: {
    Myimg:function(){
    	let that = this;
    	getMyimg().then(res=>{
    		that.myimg = res.data;
    	})
    }
  }
};
</script>
